// extracted by mini-css-extract-plugin
module.exports = {"wide":"DatePicker_wide__3SYvB"};